import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
    InnerWrapper,
    DecisionWrapper,
    PitcherWrapper,
    PlayerNameWithNoteWrapper
} from '../BoxscoreTeamTable.style';
import types from './config/BoxscoreTypes';

const { BATTING, PITCHING, BENCH, BULLPEN } = types;

const PlayerNameWithNote = (props) => {
    const { player, note, type } = props;
    return (
        <PlayerNameWithNoteWrapper>
            {note && type === BATTING && <InnerWrapper>{note}</InnerWrapper>}
            {type === PITCHING? <PitcherWrapper $enableRightPadding={!!note}>{player}</PitcherWrapper> : player}
            {note && type === PITCHING && <DecisionWrapper>{note}</DecisionWrapper>}
        </PlayerNameWithNoteWrapper>
    );
};

PlayerNameWithNote.propTypes = {
    player: PropTypes.string,
    note: PropTypes.string,
    type: PropTypes.oneOf([BATTING, PITCHING, BENCH, BULLPEN])
};

export default PlayerNameWithNote;
